
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/real-estate/categories/[id]",
      function () {
        return require("private-next-pages/real-estate/categories/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/real-estate/categories/[id]"])
      });
    }
  